import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Clock, Lock } from "lucide-react";

export function TrialBanner() {
  const { user } = useAuth();
  if (!user || user.plan !== "trial") return null;
  const locked = user.trialLocked;
  return (
    <div
      data-testid="trial-banner"
      className={`mb-4 flex flex-col items-start gap-2 rounded-xl border px-4 py-3 sm:flex-row sm:items-center sm:justify-between ${
        locked ? "border-mt-text bg-mt-text text-white" : "border-mt-primary/40 bg-mt-primary/5 text-mt-text"
      }`}
    >
      <div className="flex items-center gap-2 text-sm font-semibold">
        {locked ? <Lock size={16} /> : <Clock size={16} className="text-mt-primary" />}
        {locked
          ? "Your free trial has ended — your runs are view-only until you upgrade."
          : `Free Trial — ${user.trialDaysLeft} day${user.trialDaysLeft === 1 ? "" : "s"} left. Buy to keep your data & unlock everything.`}
      </div>
      <Link
        to="/upgrade"
        data-testid="trial-upgrade-link"
        className={`shrink-0 rounded-lg px-4 py-2 text-sm font-bold transition-transform hover:scale-[0.98] ${
          locked ? "bg-white text-mt-text" : "bg-mt-primary text-white"
        }`}
      >
        Upgrade — $24.95
      </Link>
    </div>
  );
}
